module.exports = __webpack_public_path__ + "static/media/25-4.2986fd32.mp3";